export default __webpack_public_path__ + "static/media/i_bus-dbl_gn_tagless.15690e1b.svg";